import { createSelector, createSelectorCreator } from 'reselect';
import { formValueSelector } from 'redux-form';
import { selectedInstrumentSelector } from './instrumentPositionSelectors';
import { dateFilter } from '../../helpers/orderHistoryFilters';
var formSelector = formValueSelector('order-history-filter');
var products = function products(state) {
  return state.apexCore.product.products;
};
var depositProductId = function depositProductId(state) {
  return state.deposit.product;
};
var withdrawProductId = function withdrawProductId(state) {
  return state.withdraw.product;
};
export var productsListSelector = createSelector(function (state) {
  return state.apexCore.product.products;
}, function (products) {
  return products.map(function (_ref) {
    var Product = _ref.Product,
      ProductFullName = _ref.ProductFullName,
      ProductId = _ref.ProductId,
      DecimalPlaces = _ref.DecimalPlaces;
    return {
      Product: Product,
      ProductFullName: ProductFullName,
      ProductId: ProductId,
      DecimalPlaces: DecimalPlaces
    };
  });
});
export var filteredDepositsByProductSelector = createSelector([selectedInstrumentSelector, function (state) {
  return state.deposit.depositsStatus;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}, function (state) {
  return formSelector(state, 'startDate', 'endDate');
}, function (state, props) {
  return props.filterMode;
}], function (instrument, deposits, selectedProductId, formValues, filterMode) {
  if (filterMode === 'selectedProduct') {
    return deposits.filter(function (deposit) {
      return selectedProductId ? deposit.AssetId === selectedProductId : true;
    }).filter(function (deposit) {
      return dateFilter(deposit, formValues.startDate, formValues.endDate, 'CreatedTimestamp');
    }).sort(function (a, b) {
      return new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp);
    });
  } else {
    return deposits.filter(function (deposit) {
      return deposit.AssetId === instrument.Product1 || deposit.AssetId === instrument.Product2;
    }).sort(function (a, b) {
      return new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp);
    });
  }
});
export var filteredWithdrawalsByProductSelector = createSelector([selectedInstrumentSelector, function (state) {
  return state.withdraw.withdrawTickets;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}, function (state) {
  return formSelector(state, 'startDate', 'endDate');
}, function (state, props) {
  return props.filterMode;
}], function (instrument, withdrawals, selectedProductId, formValues, filterMode) {
  if (filterMode === 'selectedProduct') {
    return withdrawals.filter(function (withdrawal) {
      return selectedProductId ? withdrawal.AssetId === selectedProductId : true;
    }).filter(function (withdrawal) {
      return dateFilter(withdrawal, formValues.startDate, formValues.endDate, 'CreatedTimestamp');
    }).sort(function (a, b) {
      return new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp);
    });
  } else {
    return withdrawals.filter(function (withdrawal) {
      return withdrawal.AssetId === instrument.Product1 || withdrawal.AssetId === instrument.Product2;
    }).sort(function (a, b) {
      return new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp);
    });
  }
});
export var depositProductSelector = createSelector([products, depositProductId], function (products, depositProductId) {
  return products.find(function (prod) {
    return prod.ProductId === depositProductId;
  });
});
export var withdrawProductSelector = createSelector([products, withdrawProductId], function (products, withdrawProductId) {
  return products.find(function (prod) {
    return prod.ProductId === withdrawProductId;
  });
});
export var depositAddressSelector = createSelector(function (state) {
  return state.deposit;
}, function (deposit) {
  var addressList = deposit.depositInfo,
    isLoading = deposit.isLoading;
  var selectedAddress = void 0;
  if (!isLoading && addressList.length) {
    selectedAddress = addressList[addressList.length - 1];
  }
  return selectedAddress;
});
export var whiteListedAddressesSelector = createSelector(function (state) {
  return state.user.selectedAccountId;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}, function (state) {
  return state.eotcWithdraw.withdrawInfos;
}, function (selectedAccountId, selectedProductId, withdrawInfos) {
  return withdrawInfos.filter(function (_ref2) {
    var AccountId = _ref2.AccountId,
      ProductId = _ref2.ProductId;
    return AccountId === selectedAccountId && ProductId === selectedProductId;
  });
});